import { render, staticRenderFns } from "./InMemoryFileUpload.vue?vue&type=template&id=2db9e514&scoped=true&"
import script from "./InMemoryFileUpload.vue?vue&type=script&lang=ts&"
export * from "./InMemoryFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./InMemoryFileUpload.vue?vue&type=style&index=0&id=2db9e514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db9e514",
  null
  
)

export default component.exports